export const TAG_TYPES = {
  cigar_band: 0,
  box: 1
};
